// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__3KdkL","mb-25":"Main_mb-25__2cLFq"};